<!-- Footer Start -->
<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        2020 &copy; Infortronix. All Rights Reserved. Design by
        <a href="https://infortronix.com" target="_blank"> Infortronix (PVT) Ltd</a>
      </div>
    </div>
  </div>
</footer>
<!-- end Footer -->
